<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div style="padding-bottom: 25px;" v-loading="loading">
      <div class="odmik-besedila-objava-stevilke">
        <span>
          Z izpolnitvijo obrazca boste oddali oddali naročilo za objavo telefonske številke v Telefonskem
          imeniku Slovenije.
        </span>
      </div>
      <el-form label-width="200px" v-if="this.formData.ime !== null" :rules="rules" ref="objavaStevilke"
               :label-position="formaOrientacija" :model="formData" class="nova-vrstica-forma">
        <el-form-item label="Ime" class="obvezno" prop="ime">
          <el-input v-model="formData.ime" class="velikost-inptu">
          </el-input>
        </el-form-item>
        <el-form-item label="Priimek" class="obvezno" prop="priimek">
          <el-input v-model="formData.priimek" class="velikost-inptu">
          </el-input>
        </el-form-item>
        <el-form-item label="Naziv podjetja" class="ni-krepko">
          <el-input v-model="formData.naziv" class="velikost-inptu">
          </el-input>
        </el-form-item>
        <el-form-item label="Spletna stran" class="ni-krepko">
          <el-input v-model="formData.url" class="velikost-inptu">
          </el-input>
        </el-form-item>
        <el-form-item label="Elektronski naslov" class="ni-krepko">
          <el-input v-model="formData.email" class="velikost-inptu">
          </el-input>
        </el-form-item>
        <el-form-item prop="objava">
          <el-checkbox v-model="potrjeniVneseniPodatki" class="krepko checkbox-potrditev">
            <span class="potrditev">
              Potrjujem, da so vnešeni podatki pravilni.
            </span>
          </el-checkbox>
          <el-checkbox v-model="formDataOriginal.objava" v-if="!formData.objava" class="krepko checkbox-potrditev prelom-checkbox">
            <span class="potrditev">
              Želim objavo v Telefonskem imeniku Slovenije.
            </span>
          </el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="postavitev-gumb" style="min-height: 52px;">
      <el-button type="primary" @click="ShraniPodatkeOObjaviStevilke(false)"
                 v-if="formData.objava !== formDataOriginal.objava"
                 class="gumb-potrdi">
        ODDAJ OBJAVO
      </el-button>
      <el-button type="primary" @click="ShraniPodatkeOObjaviStevilke(false)" v-if="formData.objava"
                 class="gumb-potrdi">
        UREDITE SPREMEMBE
      </el-button>
      <el-button type="primary" @click="ShraniPodatkeOObjaviStevilke(true)"
                 v-if="formData.objava"
                 class="gumb-potrdi">
        ODDAJ ODJAVO
      </el-button>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent'
import {Checkbox, Button, Input} from 'element-ui'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'

export default {
  name: 'ObjavaStevilke',
  mixins: [SirinaOkna],
  data () {
    return {
      loading: true,
      potrjeniVneseniPodatki: false,
      prikaziGumbShrani: false,
      novoUrejanje: false,
      formData: {
        ime: null,
        priimek: null,
        naziv: null,
        url: null,
        email: null,
        objava: [],
        idPrikljucek: null,
        stevilka: null
      },
      brezShranjenihPodatkov: false,
      formDataOriginal: {},
      mejnaSirina: 700,
      formaOrientacija: 'left',
      rules: {
        ime: [
          {
            validator: this.ValidirajUpIme
          }
        ],
        priimek: [
          {
            validator: this.ValidirajUpPriimek
          }
        ],
        objava: [
          {
            validator: this.ValidirajPotreditevPodatkov
          }
        ]
      },
      samoSpremembaPodatkov: false
    }
  },
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.PridobiPodatkeOObjaviStevilke()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  watch: {
    izbranaTelefonska: function (val) {
      if (val !== null) {
        this.PridobiPodatkeOObjaviStevilke()
      }
    }
  },
  methods: {
    PrikaziGumbZaShranitiSpremembe () {
      this.novoUrejanje = true
      this.prikaziGumbShrani = true
    },
    ValidirajUpIme (rule, upIme, callback) {
      if (upIme.length === 0) {
        return callback(new Error('Prosimo, vpišite ime.'))
      }
      callback()
    },
    ValidirajUpPriimek (rule, upIme, callback) {
      if (upIme.length === 0) {
        return callback(new Error('Prosimo, vpišite priimek.'))
      }
      callback()
    },
    ValidirajPotreditevPodatkov (rule, objava, callback) {
      if (objava.length === 0) {
        return callback(new Error('Prosim potrdite, vnešene podatke.'))
      }
      callback()
    },
    InitFormData () {
      this.formData.ime = null
      this.formData.priimek = null
      this.formData.naziv = null
      this.formData.email = null
      this.formData.objava = null
      this.formData.url = null
      this.formData.idPrikljucek = null
      this.formData.stevilka = null
    },
    PridobiPodatkeOObjaviStevilke () {
      this.loading = true
      if (this.izbranaTelefonska !== null && this.izbranPrikljucek !== null) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/telefonija/objavaStevilkeInfo',
          param,
          null,
          'SetPodatkiOObjaviStevilke',
          'ErrPodatkiOObjaviStevilke')
      }
      this.loading = false
    },
    SetPodatkiOObjaviStevilke (podatki) {
      this.loading = false
      this.InitFormData()
      if (typeof podatki.data !== 'undefined' && podatki.data !== null) {
        let data = podatki.data
        this.formData.ime = data.ime
        this.formData.priimek = data.priimek
        this.formData.naziv = data.naziv
        this.formData.email = data.email
        this.formData.objava = data.objava
        this.formData.url = data.url
        this.formData.idPrikljucek = this.izbranPrikljucek
        this.formData.stevilka = this.izbranaTelefonska
        this.formDataOriginal = {...this.formData}
        if (data.objava) {
          this.potrjeniVneseniPodatki = true
        }
        if (data.ime === '' && data.priimek === '') {
          this.brezShranjenihPodatkov = true
        }
      }
    },
    ErrPodatkiOObjaviStevilke () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Napaka pri pridobivanju podatkov o objavi številke'
      this.ShowWarningMessage(paramObvestilo)
    },
    ShraniPodatkeOObjaviStevilke (odjava) {
      this.samoSpremembaPodatkov = this.formDataOriginal.objava === this.formData.objava
      if (
        this.formDataOriginal.ime === this.formData.ime &&
        this.formDataOriginal.priimek === this.formData.priimek &&
        this.formDataOriginal.naziv === this.formData.naziv &&
        this.formDataOriginal.email === this.formData.email &&
        this.formDataOriginal.url === this.formData.url &&
        this.formDataOriginal.stevilka === this.formData.stevilka &&
        this.samoSpremembaPodatkov &&
        !odjava
      ) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nobenih sprememb podatkov ni bilo vnešenih.'
        this.ShowWarningMessage(paramObvestilo)
      } else {
        if (this.potrjeniVneseniPodatki === true) {
          this.formData.objava = !odjava
          let params = []
          Object.keys(this.formData).forEach(key => {
            params.push(key.toString() + '=' + this.formData[key])
          })
          if (this.izbranPrikljucek !== null && this.izbranaTelefonska !== null) {
            this.clientAgent.postWsRequest(this,
              'prikljucek/telefonija/posodobiImenikObjavo?',
              params,
              null,
              'SuccessMsgObjavaStevilke',
              'ErrShraniPodatkeOObjaviStevilke')
          }
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = 'Potrdite pravilnost vnešenih podatkov.'
          this.ShowWarningMessage(paramObvestilo)
        }
      }
    },
    SuccessMsgObjavaStevilke () {
      let paramObvestilo = {}
      if (!this.formData.objava) {
        paramObvestilo.message = 'Odjava uspešno urejena.'
        this.ShowSuccessMessage(paramObvestilo)
      } else if (this.formData.objava && !this.samoSpremembaPodatkov) {
        paramObvestilo.message = 'Objava uspešno urejena'
        this.ShowSuccessMessage(paramObvestilo)
      } else {
        paramObvestilo.message = 'Podatki o objavi posodobljeni.'
        this.ShowSuccessMessage(paramObvestilo)
      }
      this.PridobiPodatkeOObjaviStevilke()
      this.samoSpremembaPodatkov = false
      this.prikaziGumbShrani = false
      this.novoUrejanje = false
    },
    ErrShraniPodatkeOObjaviStevilke () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Napaka pri posodabljanju podatkov o objavi številke'
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/Telefonija/ObjavaStevilke.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/ObjavaStevilke.vue